import React from 'react';
import { Edit } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';
const LocationRateSettingEdit = () => (
  <Edit
    mutationMode="pessimistic"
    transform={getTransform(['location_id'], 'location_rate_setting')}
  >
    <RateSettingsForm settingsField="location_rate_setting" />
  </Edit>
);

export default LocationRateSettingEdit;
